import React, { useEffect, useState } from 'react'
import { stylesMUIInput } from '../stylesMUIInput'
import { useSelector } from 'react-redux'
import { RootState } from '../../../setup'
import { IconButton, MenuItem, TextField } from '@mui/material'
import { useStyles } from '../LTLandVolumeTLPages/FreightInfo/FreightInformation/FreightInformationStyles'
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import EditIcon from '@mui/icons-material/Edit';
import CollectInformationModal from './CollectInformationModal'

const BillToCollect = ({formik, setFormikValues, isCollect, setIsCollect, openCollectInformationModal, setOpenCollectInformationModal}) => {
    const fontSize = useSelector<RootState>(({pages}) => pages.fontSize) as number
    const classes = useStyles({
        fontSize: fontSize,
      })
    
    const menuProps = {
        classes: {
            list: classes.selectPaperList
        }
    }
    
    return (
        <>
            <div className="row">
                <div className="col-3 d-flex align-items-center" style={{padding: '0'}}>
                    <div className="form-check form-check-custom form-check-solid">
                    <input className="form-check-input" type="checkbox" id="bol"
                        value={isCollect}
                        checked={isCollect}
                        onChange={(e) => {
                            // setFormikValues('collect.value', e.target.value);
                            setIsCollect(e.target.checked)
                            setFormikValues('billToData', '')
                            setFormikValues('collect', 'Consignee')
                            
                        }}
                        name='isCollect'/>
                    <label className="form-check-label" htmlFor="bol">
                        Freight Bill To
                    </label>
                    </div>
                </div>
                {
                    isCollect ?
                        <div className="col-5 d-flex align-items-center justify-content-center">
                            <TextField
                                select
                                label=" "
                                defaultValue='Consignee'
                                name='collect'
                                value={formik.values.collect}
                                onChange={(e) => {
                                    // setFormikValues('collect.value', e.target.value);
                                    if (e.target.value) {
                                        setFormikValues('collect', e.target.value)
                                        // formik.setFieldValue('collect', collectValues)
                                        if(e.target.value == 'Third Party') {
                                            setOpenCollectInformationModal(true);
                                        }
                                    }
                                    
                                }}
                                className={`${classes.selectMUI} w-100 me-2`}
                                InputProps={{
                                    style: stylesMUIInput(fontSize),
                                }}
                                SelectProps={{
                                    IconComponent: KeyboardArrowDownIcon,
                                    MenuProps: menuProps
                                }}
                                InputLabelProps={{shrink: false}}
                            >
                                <MenuItem value="Consignee">Consignee (Collect)</MenuItem>
                                <MenuItem value="Third Party">Third Party (3rd Pty)</MenuItem>
                            </TextField>
                            {  
                                formik.values.collect === 'Third Party'
                                ? <IconButton onClick={() => setOpenCollectInformationModal(true)}>
                                    <EditIcon style={{width: 21, height: 21}}/>
                                </IconButton>
                                : null
                            }
                        </div>
                    : null
                }
            </div>
            <CollectInformationModal
                open={openCollectInformationModal}
                setOpen={setOpenCollectInformationModal}
                formik={formik}
            />
        </>        
    )
}

export default BillToCollect